import tracking from './configs/tracking';
import SectionTracker from './sectionTracker';

const env = window.env || 'production';
const reportingSuiteId = env === 'production' ? 'milbglobal,milb' : 'mlbdevmilbglobal';

window.trackAsync = function (asyncProps) {
    asyncTracking(asyncProps);
};

function asyncTracking(asyncProps) {
    let CLEAR_VARS = [
        'eVar13',
        'prop25',
        'eVar28',
        'prop26',
        'prop27',
        'prop28',
        'prop29',
        'prop30',
        'prop32',
        'prop33',
        'prop34',
        'prop43',
        'prop49',
        'eVar49',
        'prop54'
    ];

    let clearVars = function (s) {
        CLEAR_VARS.forEach(function (prop) {
            delete s[CLEAR_VARS[prop]];
        });
        delete s.events;
    };

    var s = window.s_gi(reportingSuiteId);

    s.clearVars();
    clearVars(s);
    s.eVar73 = reportingSuiteId;
    s = Object.assign(s, asyncProps);

    s.tl(true, 'o', 'http://myGenericURL');
}

function setCustomTrackingVars(trackObj, el) {
    const siteName = window.siteName || 'MiLB.com';
    const $el = $(el);
    const dropdownLabel = $el.closest('div[data-label]').data('label');
    const standardExpandedValue = $el.attr('aria-label');
    const innerText = $el.text();

    $.each(trackObj, (prop, val) => {
        let value = val.toString();

        if (value.indexOf('@') !== -1) {
            if (value.match(/@SITE_NAME@/)) {
                value = value.replace(/@SITE_NAME@/, siteName);
            }

            if (value.match(/@DROPDOWN_LABEL@/)) {
                value = value.replace(/@DROPDOWN_LABEL@/, dropdownLabel);
            }

            if (value.match(/@DROPDOWN_VALUE@/)) {
                value = value.replace(/@DROPDOWN_VALUE@/, innerText);
            }

            if (value.match(/@STANDARD_ADVANCED@/)) {
                value = value.replace(/@STANDARD_ADVANCED@/, standardExpandedValue);
            }

            if (value.match(/@FULL_TEAM_NAME@/)) {
                value = value.replace(/@FULL_TEAM_NAME@/, innerText);
            }

            trackObj[prop] = value;
        }

        // Remove any bad props.
        if (trackObj[prop] === 'undefined' || trackObj[prop] === null) {
            delete trackObj[prop];
        }
    });
    return trackObj;
}

export default function () {
    const sectionTracker = new SectionTracker(tracking, setCustomTrackingVars, {});
    sectionTracker.init();
}
